import { axios } from './axios';

export const login = (data: { email: string; password: string }) => {
  return axios.post('/trainer-api/login', data);
};

export const logout = () => {
  return axios.post('/trainer-api/logout');
};

export const getUser = () => {
  return axios.get('/trainer-api/get_user');
};

export const updateProfile = (data: { name: string; mobile: string }) => {
  return axios.post('/trainer-api/update_profile', data);
};

export const forgetpassword = (data: { email: string }) => {
  return axios.post('/trainer-api/request_forgetpassword_otp', data);
};

export const verifyPasswordOTP = (data: { email: string; otp: string }) => {
  return axios.post('/trainer-api/verify_forgetpassword_otp', data);
};

export const resetPassword = (data: {
  email?: string;
  otp: string;
  password: string;
  password_confirmation: string;
}) => {
  return axios.post('/trainer-api/reset_password', data);
};

export const resetPasswordFirstTime = (data: {
  password: string;
  password_confirmation: string;
}) => {
  return axios.post('/trainer-api/reset_password_firsttime', data);
};

export const getCourse = () => {
  return axios.get('/trainer-api/getAssignedCourse');
};

export const getCourseByCoAssessor = () => {
  return axios.get('/trainer-api/getAssignedCourse?co_assessor=1');
};

export const getCourseRun = (data: {
  course_id: string | number;
  date_start: string;
  date_end: string;
  from_type?: string;
}) => {
  return axios.post('/trainer-api/getCourseRun', data);
};

export const getCourseLearner = (data: { courserun_id: string | null }) => {
  return axios.post('/trainer-api/getCourseLearner', data);
};

export const getLearnerAssessment = (data: { courserun_id: string | null }) => {
  return axios.post('/trainer-api/getLearnerAssessment', data);
};

export const getCourseDetail = (data: {
  course_id: string | null;
  courserun_id: string | null;
}) => {
  return axios.post('/trainer-api/getCourseDetail', data);
};

// export const getEvaluationData = () => {
//   return axios.post('/trainer-api/getEvaluationData');
// };
export const getAllCourse = () => {
  return axios.post('/trainer-api/getAllCourse');
};

export const getTrainerSupport = (data: { courserun_id: string | null }) => {
  return axios.post('/trainer-api/getTrainerSupport', data);
};

export const getAssessmentDetail = (data: { assessment_id: string | null }) => {
  return axios.post('/trainer-api/getAssessmentDetail?test_1=2', data);
};

export const getReportDetail = (data: { assessment_id: string | null }) => {
  return axios.post('/trainer-api/getReportDetail', data);
};

export const getReportData = (data: {
  filter_date_start: string | null;
  filter_date_end: string | null;
  filter_trainer: string | null;
}) => {
  return axios.post('/trainer-api/getReportData', data);
};

export const evaluationSubmission = (data: {
  section1: [];
  section2: [];
  section3: [];
  section4: [];
  courseRunId: string;
}) => {
  return axios.post('/trainer-api/evaluationSubmission', data);
};

export const assessmentSubmission = (data: { data: []; assessment_id: string }) => {
  return axios.post('/trainer-api/assessmentSubmission', data);
};

export const assessmentReportSubmission = (data: { data: []; assessment_id: string }) => {
  return axios.post('/trainer-api/assessmentReportSubmission', data);
};

export const acknowledgeSubmission = (data: { courseRunId: string }) => {
  return axios.post('/trainer-api/acknowledgeSubmission', data);
};

export const trainerEvaluationSubmission = (data: {
  answers: [];
  courseRunId: string;
  day?: number | null;
}) => {
  return axios.post('/trainer-api/trainerEvaluationSubmission', data);
};

export const zipTrainerDocument = (data: { file: [] }) => {
  return axios.post('/trainer-api/zipTrainerDocument', data);
};

export const syncGoogleCal = () => {
  return axios.post('/trainer-api/syncGoogleCal');
};

export const getUnassignCourse = (data: {
  date_start: string;
  date_end: string;
  location_id: number[] | string[];
  course_id: number[] | string[];
}) => {
  return axios.post('/trainer-api/getUnassignCourse', data);
};

export const getSubmittedCourseRecord = (data: {
  filter_date_start: string | null;
  filter_date_end: string | null;
}) => {
  return axios.post('/trainer-api/getTrainerSubmittedClasses', data);
};

export const submitInterest = (data: { courseRunId: string }) => {
  return axios.post('/trainer-api/submitInterest', data);
};

export const getCourseColor = () => {
  return axios.get('/trainer-api/getCourseColor');
};

export const getTrainingLocation = () => {
  return axios.get('/trainer-api/getTrainingLocation');
};

export const withdrawInterest = (data: { id: string | null }) => {
  return axios.post('/trainer-api/withdrawInterest', data);
};

// trainer invoices
export const getInvoiceListing = (data: {}) => {
  return axios.post('/trainer-api/getInvoiceListing', data);
};

export const getTimesheetListing = (data: {}) => {
  return axios.post('/trainer-api/getTimesheetListing', data);
};

export const getInvoiceAvailableCourserun = (data: {}) => {
  return axios.post('/trainer-api/getInvoiceAvailableCourserun', data);
};

export const getInvoiceAvailableEnhancedMonths = (data: {} = {}) => {
  return axios.post('/trainer-api/getAvailableEnhancedMonths', data);
};

export const getInvoiceDetails = (data: { invoice_id: string | null }) => {
  return axios.post('/trainer-api/getInvoiceDetails', data);
};

interface Allowance {
  allowance_title: string;
  allowance_amount: number;
  allowance_image: File; // Assuming this is a File object for uploads
}

export const submitInvoice = (data: {
  selected_courseruns: [];
  enhanced_rate_billing_month: string[];
  invoice_no: string;
  vendor_name: string;
  invoice_date: string;
  invoice_total_amount: string | number;
  total_trainer_fee: string | number;
  total_traqom_incentive: string | number;
  total_bilingual_incentive: string | number;
  total_learners_incentive: string | number;
  is_paynow: boolean;
  bank_account_number: string;
  bank_name: string;
  bank_recipient_name: string;
  paynow_mobile_no: string;
  paynow_recipient_name: string;
  paynow_uen: string;
  allowances: Allowance[];
}) => {
  const formData = new FormData();

  data.selected_courseruns.forEach((cr, index) => {
    formData.append('selected_courseruns[]', cr);
  });
  data.enhanced_rate_billing_month.forEach((month) => {
    formData.append('enhanced_rate_billing_month[]', month);
  });
  formData.append('invoice_no', data.invoice_no);
  formData.append('vendor_name', data.vendor_name);
  formData.append('invoice_date', data.invoice_date);
  formData.append('invoice_total_amount', parseFloat(String(data.invoice_total_amount)).toFixed(2));
  formData.append('total_trainer_fee', parseFloat(String(data.total_trainer_fee)).toFixed(2));
  formData.append(
    'total_traqom_incentive',
    parseFloat(String(data.total_traqom_incentive)).toFixed(2)
  );
  formData.append(
    'total_bilingual_incentive',
    parseFloat(String(data.total_bilingual_incentive)).toFixed(2)
  );
  formData.append(
    'total_learners_incentive',
    parseFloat(String(data.total_learners_incentive)).toFixed(2)
  );
  formData.append('is_paynow', data.is_paynow ? 'true' : 'false');
  formData.append('bank_account_number', data.bank_account_number);
  formData.append('bank_name', data.bank_name);
  formData.append('bank_recipient_name', data.bank_recipient_name);
  formData.append('paynow_mobile_no', data.paynow_mobile_no);
  formData.append('paynow_recipient_name', data.paynow_recipient_name);
  formData.append('paynow_uen', data.paynow_uen);
  formData.append('allowances', JSON.stringify(data.allowances));

  // Append allowances fields and files
  data.allowances.forEach((allowance, index) => {
    formData.append(`allowances[${index}][allowance_title]`, allowance.allowance_title);
    formData.append(
      `allowances[${index}][allowance_amount]`,
      parseFloat(String(allowance.allowance_amount)).toFixed(2)
    );
    formData.append(`allowances[${index}][allowance_image]`, allowance.allowance_image); // File upload
  });

  return axios.post('/trainer-api/submitInvoice', formData, {
    headers: {
      'Content-Type': 'multipart/form-data', // Important for handling file uploads
    },
  });
};

export const printInvoice = (data: { invoice_id: string | number }) => {
  return axios.post('/trainer-api/printInvoice', data);
};

// timesheets
export const submitTimesheet = (data: {
  date: string;
  sign_in_coa: string;
  course_name: string;
  course_run_id: string;
  remarks: string;
  trainer_id: number;
}) => {
  return axios.post('/trainer-api/submitTimesheet', data);
};

export const getTimesheetDetails = (data: { timesheet_id: string | number }) => {
  return axios.get('/trainer-api/getTimesheetDetails', { params: data });
};

export const updateTimesheet = (data: {
  timesheet_id: string | number;
  date: string;
  sign_in_coa: string;
  signed_by_ts_sign_in: string;
  course_name: string;
  course_run_id: string;
  no_of_assessment: number;
  sign_out_coa: string;
  signed_by_ts_sign_out: string;
  no_of_hours_worked: number;
  remarks: string;
}) => {
  return axios.post('/trainer-api/updateTimesheet', data);
};

export const endTimesheet = (data: {
  timesheet_id: string | number;
  date: string;
  no_of_assessment: number;
  sign_out_coa: string;
  no_of_hours_worked: number;
  remarks: string;
}) => {
  return axios.post('/trainer-api/endTimesheet', data);
};

export const validateTimesheetDate = (data: {
  // date: string;
  trainer_id: string | number;
  // timesheet_id?: string | number;
  courserun_id?: string | number;
}) => {
  return axios.post('/trainer-api/validateTimesheetDate', data);
};
